/**
 * snooze -- mise en pause temporaire des appels vers un prospect (#56).
 *
 * Un prospect "snooze" n'est PAS un prospect archive ni un DNC : il reste
 * actif, il est simplement injoignable jusqu'a une date. C'est pourquoi le
 * blocage vit dans canCall() (droit d'appeler MAINTENANT) et non dans
 * dialIntent() (categorie commerciale du prospect).
 *
 * ⚠️ Le champ `snoozed_until` doit etre porte par le schema backend
 * (ProspectQueue). Non constate depuis cet environnement de test.
 */

/** Le prospect est-il en pause a cet instant ? */
export function isSnoozed(prospect: any, now: Date = new Date()): boolean {
  const jusqua = prospect?.snoozed_until;
  if (!jusqua) return false;
  const d = new Date(jusqua);
  if (isNaN(d.getTime())) return false;
  return d.getTime() > now.getTime();
}

/** Ajoute n jours OUVRES (samedi et dimanche sautes) a une date. */
export function addJoursOuvres(depuis: Date, n: number): Date {
  const d = new Date(depuis.getTime());
  let restants = n;
  while (restants > 0) {
    d.setDate(d.getDate() + 1);
    const j = d.getDay();
    if (j !== 0 && j !== 6) restants -= 1;
  }
  return d;
}

/** Prochain jour de la semaine donne (1 = lundi ... 5 = vendredi). */
export function prochainJour(depuis: Date, cible: number): Date {
  const d = new Date(depuis.getTime());
  do { d.setDate(d.getDate() + 1); } while (d.getDay() !== cible);
  return d;
}

/**
 * Les durees proposees. Le client cite "Dans 3 jours ouvres / Vendredi" --
 * on garde ces deux-la et on encadre d'un cran plus court et de deux plus longs.
 */
export const SNOOZE_OPTIONS: { key: string; calcule: (d: Date) => Date }[] = [
  { key: 'demain',        calcule: (d) => addJoursOuvres(d, 1) },
  { key: 'troisJours',    calcule: (d) => addJoursOuvres(d, 3) },
  { key: 'vendredi',      calcule: (d) => prochainJour(d, 5) },
  { key: 'uneSemaine',    calcule: (d) => addJoursOuvres(d, 5) },
  { key: 'unMois',        calcule: (d) => { const x = new Date(d.getTime()); x.setMonth(x.getMonth() + 1); return x; } },
];
